import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCredentials } from "../../features/auth/authSlice";
import axios from "axios";

const MicrosoftCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  const handleMicrosoftAuth = async () => {
    try {
      window.open(`${process.env.REACT_APP_BACKEND_URL}/auth/microsoft`, "_self");
    } catch (error) {
      if (!error.status) setError("No response from server");
      else if (error.status === 400 || error.status === 404)
        setError(error.data.message);
      else setError("An error occurred. Please try again.");
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        // Parse the query string
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get("token");
        const errorParam = queryParams.get("error");
        const errorMessage = queryParams.get("message");

        // Handle authentication errors
        if (errorParam) {
          setError(errorMessage || "Microsoft authentication failed");
          setTimeout(() => {
            navigate(`/signin?error=${errorParam}`);
          }, 2000);
          return;
        }

        if (!token) {
          handleMicrosoftAuth();
          // setError("No authentication token received");
          // setTimeout(() => {
          //   navigate("/signin?error=missing-token");
          // }, 2000);
          return;
        }

        // Get user data from Microsoft SSO endpoint
        const resp = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/auth/microsoft/user`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = resp?.data?.data;

        // Set credentials in Redux store
        dispatch(
          setCredentials({
            token: data.accessToken,
            user: data.user,
          })
        );

        // Navigate based on onboarding status
        if (data.hasCompletedOnboarding) {
          navigate("/home");
        } else {
          if (data?.user?.step >= 4) {
            navigate("/welcome");
          } else {
            const number = 3;
            const numberString = number.toString();
            const base64Encoded = btoa(numberString);
            navigate(`/signin?step=${base64Encoded}`);
          }
        }
      } catch (err) {
        console.error("Microsoft callback error:", err);
        setError(err.response?.data?.message || "Authentication failed");
        setTimeout(() => {
          navigate("/signin?error=microsoft-authentication-failed");
        }, 2000);
      }
    };

    init();
  }, [location, navigate, dispatch]);

  // Show loading or error state
  if (error) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="text-center">
          <div className="text-red-500 text-xl mb-2">Authentication Error</div>
          <div className="text-gray-600">{error}</div>
          <div className="text-sm text-gray-400 mt-2">Redirecting to sign in...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
        <div className="text-gray-600">Completing Microsoft sign in...</div>
      </div>
    </div>
  );
};

export default MicrosoftCallback;

